<template>
  <div>
    <div
      class="hero has-margin-top-20 is-primary has-background border-radius-0"
    >
      <!-- <img
        class="hero-background"
        src="/images/training.jpg"
        alt="Training Background"
      /> -->
      <div class="hero-body">
        <div
          class="container"
          :class="
            screen === 'mobile' ? '' : 'padding-right-80px padding-left-80px'
          "
        >
          <h1 class="title">के तपाईं तालिम लिन इच्छुक हुनुहुन्छ?</h1>
          <small class="has-text-white is-size-6">
            तालिमको मुख्य उद्देश्य तपाईंको व्यक्तित्व, आत्मबिश्वास र सिप बिकास
            गर्नु हो। यदि तपाईं आफ्नो व्यक्तित्व आकर्षक र आत्मविश्वासि भएको
            हेर्न चाहनु हुन्छ भने तपाईं तालिम लिएर व्यवसायिक सिप बिकास गर्न
            सक्नु हुन्छ। तपाईं Soft skill अथवा vocational तालिम लिएर आत्मनिर्भर
            र सक्षम बन्न सक्नुहुन्छ। Soft Skill र vocational तालिमले तपाईंको
            व्यक्तित्वमा निखार ल्याउनुको साथै तपाईंको व्यवहारिक र व्यवसायिक सिप
            विकास गर्न मद्त गर्छ।
          </small>
        </div>
      </div>
    </div>
    <section
      id="current-trainings"
      class="container py-5"
      :class="
        screen === 'mobile' ? 'text-11' : 'padding-right-80px padding-left-80px'
      "
    >
      <div class="columns is-mobile is-centered is-multiline mx-1">
        <div class="column mt-n8 is-10-mobile is-5-desktop">
          <div class="columns is-mobile is-centered box is-paddingless">
            <div class="column is-narrow">
              <div
                class="has-text-black has-text-weight-bold pointer"
                @click="$options.scrollToContent('current-trainings')"
              >
                {{ $t('currentTraining') }}
                <span class="is-size-7"> ({{ currentCount }}) </span>
              </div>
            </div>
            <div
              class="column is-narrow"
              :class="screen === 'mobile' ? 'px-0' : ''"
            >
              |
            </div>
            <div class="column pointer is-narrow">
              <div
                class=""
                @click="$options.scrollToContent('upcoming-trainings')"
              >
                {{ $t('upcomingTraining') }}
                <span class="is-size-7"> ({{ upcomingCount }}) </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="container"
      :class="screen === 'mobile' ? '' : 'padding-right-80px padding-left-80px'"
    >
      <training-list
        collection-name="trainingDetail"
        title="currentTraining"
        @totalCount=";(currentCount = $event), (showUpcoming = true)"
        @scroll="$options.scrollToContent('current-trainings')"
      ></training-list>
    </section>
    <div class="has-text-centered mt-12">
      <dfp-slot
        id="div-gpt-ad-1580375576534-0"
        :path="'/35754210/TP'"
        mapping-training
        :size="[
          [720, 300],
          [320, 100]
        ]"
      />
    </div>

    <section
      v-if="showUpcoming"
      id="upcoming-trainings"
      class="container py-5"
      :class="screen === 'mobile' ? '' : 'padding-right-80px padding-left-80px'"
    >
      <training-list
        collection-name="upcomingTraining"
        title="upcomingTraining"
        is-upcoming
        @totalCount="upcomingCount = $event"
        @scroll="$options.scrollToContent('upcoming-trainings')"
      ></training-list>
    </section>
  </div>
</template>

<script>
import TrainingList from '@/components/Homepage/TrainingList'
import DfpSlot from '@/components/DfpSlot'
import { scrollToContent } from '@/helpers/utils/common.js'
import { mapGetters } from 'vuex'
export default {
  components: {
    TrainingList,
    DfpSlot
  },
  scrollToContent,
  data() {
    return {
      currentCount: 0,
      upcomingCount: 0,
      showUpcoming: false
    }
  },
  computed: {
    ...mapGetters({ screen: 'getScreen' })
  },
  head() {
    return {
      title: `Trainings | Rojgari`
    }
  }
}
</script>

<style lang="css">
.hero.has-background {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
}
.hero-background {
  position: absolute;
  object-fit: cover;
  object-position: center center;
  width: 100%;
  height: 100%;
}
</style>
